import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Link as LinkIcon, Copy, ExternalLink, Check } from "lucide-react";
import { toast } from "sonner";

export default function PublicUrlBanner() {
  const [slug, setSlug] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => setSlug(r.data?.tenant_slug || "")).catch(() => {});
  }, []);

  if (!slug) return null;

  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const fullUrl = `${origin}/${slug}`;
  const displayUrl = `book-it.com.mx/${slug}`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success("URL copiada");
      setTimeout(() => setCopied(false), 1800);
    } catch { toast.error("No pudimos copiar"); }
  }

  return (
    <div
      className="rounded-xl border border-slate-200 bg-white px-5 py-4 flex items-center justify-between gap-4 flex-wrap"
      data-testid="admin-public-url-banner"
      style={{ background: "linear-gradient(90deg, rgba(239,246,255,1) 0%, rgba(255,255,255,1) 60%)" }}
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="h-9 w-9 rounded-lg grid place-items-center shrink-0" style={{ background: "#1E3A8A" }}>
          <LinkIcon className="h-4 w-4 text-white" />
        </div>
        <div className="min-w-0">
          <p className="text-[10px] tracking-[0.18em] uppercase text-slate-500">Tu URL pública de reservas</p>
          <p className="font-mono text-sm sm:text-base font-medium truncate" style={{ color: "#1E3A8A" }} data-testid="admin-public-url-text">
            {displayUrl}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button size="sm" variant="outline" onClick={copy} data-testid="admin-public-url-copy">
          {copied ? <Check className="h-3 w-3 mr-1" /> : <Copy className="h-3 w-3 mr-1" />} {copied ? "Copiada" : "Copiar"}
        </Button>
        <Button size="sm" onClick={() => window.open(fullUrl, "_blank")} data-testid="admin-public-url-open">
          <ExternalLink className="h-3 w-3 mr-1" /> Abrir
        </Button>
      </div>
    </div>
  );
}
